module.exports = __webpack_public_path__ + "static/media/trans-non-binary.37eaa8ff.png";